import type { ComponentType } from 'react'
import { KIND } from 'baseui/button'
import BaseSDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import IconBan from '@/shared/icons/NewDesign/IconBan'
import IconExternalLink from '@/shared/icons/NewDesign/IconExternalLink'
import IconMessage from '@/shared/icons/NewDesign/IconMessage'
import ContractActionsModal from '../../../../ContractsTable/cells/ContractActionsModal'
import IconActionButton from './IconActionButton/IconActionButton'
import useRowActions from './useRowActions'
import { Contract } from '../../../../types'
import { ActionsRow } from '../../styled-components'

const SDButton = BaseSDButton as ComponentType<any>

interface RowActionsProps {
  contract: Contract
  getContracts: () => void
  formInitUrl: string
}

const RowActions = (props: RowActionsProps) => {
  const {
    isOpen,
    modalType,
    openContract,
    openAbandon,
    openComments,
    dismissModal,
    handleAbandonSubmit,
    handleCommentSubmit,
    isLoadingComments,
    comments,
    canAbandon,
    editLabel,
    commentsLabel,
    abandonLabel,
    editOverrides,
    iconOverrides,
    abandonOverrides,
    tooltipOverrides,
  } = useRowActions(props)

  return (
    <ActionsRow>
      <SDButton
        kind={KIND.secondary}
        onClick={openContract}
        overrides={editOverrides}
        endEnhancer={<IconExternalLink />}
      >
        {editLabel}
      </SDButton>
      <IconActionButton
        label={commentsLabel}
        Icon={IconMessage}
        onClick={openComments}
        overrides={iconOverrides}
        tooltipOverrides={tooltipOverrides}
      />
      <IconActionButton
        label={abandonLabel}
        Icon={IconBan}
        onClick={openAbandon}
        overrides={abandonOverrides}
        tooltipOverrides={tooltipOverrides}
        hidden={!canAbandon}
      />
      <ContractActionsModal
        isOpen={isOpen}
        modalType={modalType}
        onClose={dismissModal}
        onAbandonSubmit={handleAbandonSubmit}
        onCommentSubmit={handleCommentSubmit}
        comments={comments}
        isLoadingComments={isLoadingComments}
      />
    </ActionsRow>
  )
}

export default RowActions
